/**
 * ID 生成工具
 */

/** 生成带前缀的唯一 id（优先 crypto.randomUUID，降级到时间随机串） */
export function genId(prefix = 'id'): string {
  const uuid =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  return `${prefix}_${uuid}`;
}
